import type { EmailDeliverySummaryGroup as GQLItem } from '../../../generated/internal.graphql';
import * as EmailDeliveryMeasures from './EmailDeliveryMeasures';

/**
 * One row of the grouped report: the value the rollup was grouped by, and what that group measures.
 *
 * Inside the `EmailDeliverability/` domain rather than top-level because it is reachable only
 * through `EmailDeliverySummary.groups`.
 */
export type EmailDeliverySummaryGroup = {
  key?: string;
  measures: EmailDeliveryMeasures.EmailDeliveryMeasures;
};

/**
 * `key` is the grouped column's own value, so it is null exactly when that column is — an
 * unattributed account, or a send with no mail stream. Normalised to `undefined` like every other
 * nullable in this namespace: nothing in the admin renders a `null`, and a `v-if` on one prints the
 * string rather than falling through to the empty branch.
 */
export const fromGql = (item: GQLItem): EmailDeliverySummaryGroup => ({
  key: item.key ?? undefined,
  measures: EmailDeliveryMeasures.fromGql(item.measures),
});
